import { types, Instance } from 'mobx-state-tree';
import { set } from 'mobx';

export const CartItemOptionModel = types.model({
  id: types.string,
  optionText: types.string,
});
export interface ICartItemOptionModel
  extends Instance<typeof CartItemOptionModel> {}
export const CartItemTaxModel = types.model({
  tax1: types.number,
  tax2: types.number,
  tax3: types.number,
});
export interface ICartItemTaxModel extends Instance<typeof CartItemTaxModel> {}
export const CartItemGiftWrapModel = types.model({
  price: types.number,
  message: types.string,
  selected: types.boolean,
});
export interface ICartItemGiftWrapModel
  extends Instance<typeof CartItemGiftWrapModel> {}
export const CartItemKitModel = types.model({
  code: types.string,
  name: types.maybeNull(types.string),
  quantity: types.number,
  cost: types.number,
  optionId: types.union(types.string, types.number),
  isSetupCost: types.boolean,
  imgUrl: types.string,
  productUrl: types.string,
});
export interface ICartItemKitModel extends Instance<typeof CartItemKitModel> {}
export const CartItemPricingRecurringModel = types.model({
  price: types.number,
  startPrice: types.number,
  thenXMonths: types.string,
  everyXMonths: types.string,
  startXMonths: types.maybeNull(types.number),
});
export type ICartItemPricingRecurringModel = Instance<
  typeof CartItemPricingRecurringModel
>;
export const CartItemPricingModel = types.model({
  unitPrice: types.number,
  subtotal: types.number,
  recurringPrice: CartItemPricingRecurringModel,
});
export interface ICartItemPricingModel
  extends Instance<typeof CartItemPricingModel> {}
export const CartItemModel = types
  .model({
    id: types.number,
    code: types.string,
    name: types.string,
    productUrl: types.string,
    imgUrl: types.string,
    qty: types.number,
    pricing: CartItemPricingModel,
    taxable: types.boolean,
    tax: CartItemTaxModel,
    options: types.array(CartItemOptionModel),
    kits: types.array(CartItemKitModel),
    isGiftWrapAvailable: types.boolean,
    giftWrap: CartItemGiftWrapModel,
    giftCardToName: types.maybeNull(types.string),
    giftCardSendMethod: types.maybeNull(types.string),
    giftCardEmailAddress: types.maybeNull(types.string),
    giftCardFromName: types.maybeNull(types.string),
    giftCardMessage: types.maybeNull(types.string),
  })
  .views(self => ({
    get priceEach(): number {
      return self.pricing.unitPrice;
    },
    get priceTotal(): number {
      return self.pricing.subtotal;
    },
    // Simple views of CartItem for specific components as needed - ie Cart panel
  }))
  .actions(self => {
    const updateQty = (newQty: number): void => {
      const newSubTotal = self.priceEach * newQty;
      set(self.pricing, { subtotal: newSubTotal });
      set(self, { qty: newQty });
    };
    // Will removeItem exist here or on CartModel?
    return {
      updateQty,
    };
  });
export interface ICartItemModel extends Instance<typeof CartItemModel> {}
